import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import LandingHome from './pages/landing/Home';
import LandingApplyLoan from './pages/landing/ApplyLoan';
import LandingSuccess from './pages/landing/Success';
import LandingError from './pages/landing/Error';

import DealerLogin from './pages/dealer/Login';

import AdminBasicExample from './pages/admin/BasicExample';
import AdminEuroKarsRef1 from './pages/admin/EuroKarsRef1';
import AdminEuroKarsRef2 from './pages/admin/EuroKarsRef2';


function Router() {
    return (
        <Routes>
            <Route path="/landing/" element={<LandingHome/>} />
            <Route path="/landing/apply-loan" element={<LandingApplyLoan/>} />
            <Route path="/landing/success" element={<LandingSuccess/>} />
            <Route path="/landing/error" element={<LandingError/>} />


            <Route path="/dealer/" element={<DealerLogin/>} />
            

            <Route path="/admin/" element={<AdminBasicExample/>} />
            <Route path="/admin/euroref1" element={<AdminEuroKarsRef1/>} />
            <Route path="/admin/euroref2" element={<AdminEuroKarsRef2/>} />


            {/* fallback */}
            <Route path="*" element={<Navigate to="/landing/apply-loan" replace />} />
        </Routes>
    );
}

export default Router;